import React from "react";

const NotFoundPage = ({ onBack }) => {
  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
    } else if (typeof window !== "undefined") {
      window.location.href = "/";
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-xl rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-slate-900 text-sm font-semibold text-white">
            IU
          </div>
          <div>
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
              404 not found
            </div>
            <h1 className="text-2xl font-semibold text-slate-900">
              We could not find that page
            </h1>
          </div>
        </div>

        <p className="text-sm text-slate-600">
          The link may be out of date or the page might have moved. Use the
          button below to head back to your invoices.
        </p>

        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:items-center">
          <button
            type="button"
            onClick={handleBack}
            className="inline-flex items-center justify-center rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-slate-800"
          >
            Back to app
          </button>
          <div className="text-xs text-slate-500">
            Still lost? Try the button above or check the URL.
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
